<template>
  <div class="equity-payment-result">

    <p v-if="!processPaymentComplete"
       class="block">
      Processing payment, please wait...
    </p>

    <div v-if="processPaymentComplete && processPaymentFailed">
      <br /><br />
      <b-notification type="is-warning"
                      :closable="false"
                      >
        <p class="block">
          Oh no!&nbsp; We failed to process your payment...
        </p>
        <p class="block">
          Please reach out to Member Services at (916) 868-6375.
        </p>
      </b-notification>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Equity',
    props: {
        resultType: String,
    },
    data() {
        return {
            inited: false,
            processPaymentComplete: false,
            processPaymentFailed: false,
        }
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // is someone logged in?
            if (this.$store.state.user.uuid) {

                // only load page if it's a member
                if (this.$store.state.user.member) {

                    // was payment canceled?
                    if (this.resultType == 'cancel') {

                        // tell server to cancel payment
                        this.$http.post('/api/my/equity/cancel-payment').then(response => {

                            // go back to equity page and show cancel msg
                            this.$router.push('/equity')
                            this.$buefy.toast.open({
                                message: "Payment was canceled",
                                type: 'is-warning',
                                duration: 4000, // 4 seconds
                            })

                        }, response => {

                            // something went wrong with the cancel, but ultimately
                            // we don't care and do the same thing as if it worked

                            // go back to equity page and show cancel msg
                            this.$router.push('/equity')
                            this.$buefy.toast.open({
                                message: "Payment was canceled",
                                type: 'is-warning',
                                duration: 4000, // 4 seconds
                            })

                        })

                    } else { // payment success

                        // try to process equity payment for the
                        // account, then redirect to equity page...

                        let params = {
                            'stripe_session_id': new URL(location).searchParams.get('s'),
                        }

                        if (!params.stripe_session_id) {
                            this.$buefy.toast.open({
                                message: "Failed to process payment:  unknown session ID",
                                type: 'is-warning',
                                duration: 4000, // 4 seconds
                            })
                            this.processPaymentFailed = true
                            this.processPaymentComplete = true
                        }

                        this.$http.post('/api/my/equity/process-payment', params).then(response => {
                            if (response.data.ok) {
                                this.processPaymentComplete = true

                                // go back to equity page and show success msg
                                this.$router.push('/equity')
                                this.$buefy.toast.open({
                                    message: `Payment has been processed for ${response.data.amount}`,
                                    type: 'is-info',
                                    duration: 4000, // 4 seconds
                                })

                            } else {
                                this.$buefy.toast.open({
                                    message: `Failed to process payment:  ${response.data.error || 'unknown error'}`,
                                    type: 'is-warning',
                                    duration: 4000, // 4 seconds
                                })
                                this.processPaymentFailed = true
                                this.processPaymentComplete = true
                            }

                        }, response => {
                            this.$buefy.toast.open({
                                message: "Failed to process payment:  unknown error",
                                type: 'is-warning',
                                duration: 4000, // 4 seconds
                            })
                            this.processPaymentFailed = true
                            this.processPaymentComplete = true
                        })

                    }


                } else { // send non-members back to "home" page
                    this.$router.push('/benefits')
                }
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },
    },
}
</script>
